import { DashboardContext } from '../../types/dashboard';

export const DashboardPageContext: DashboardContext = {
	subNavContext: {},
	dashboard: {
		name: '',
		boxes: {},
	},
};
